__turbopack_context__.v({
  "desktop": "OA5U6a_desktop",
  "embla": "OA5U6a_embla",
  "emblaContainer": "OA5U6a_emblaContainer",
  "mobile": "OA5U6a_mobile",
  "mobileDescription": "OA5U6a_mobileDescription",
  "mobileEmbla": "OA5U6a_mobileEmbla",
  "mobileEmblaContainer": "OA5U6a_mobileEmblaContainer",
  "mobileHeader": "OA5U6a_mobileHeader",
  "mobileHeaderTitle": "OA5U6a_mobileHeaderTitle",
  "mobileTitle": "OA5U6a_mobileTitle",
  "mobileTitleSection": "OA5U6a_mobileTitleSection",
  "mobileVisionLink": "OA5U6a_mobileVisionLink",
  "progressBar": "OA5U6a_progressBar",
  "progressFill": "OA5U6a_progressFill",
  "progressTrack": "OA5U6a_progressTrack",
});
